<template>
  <div class='page-start'>
    <mdb-container class="col-12 pb-3" fluid>
      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1_success" @closeAlert="p1_success=false" dismiss>
				Success! ITCR has been audited!
			</mdb-alert>
      <!--failure messages-->
			<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p1_fail" @closeAlert="p1_fail=false" dismiss>
				There was an error submitting the audit report. Please try again! Error Code P1_fail
			</mdb-alert>

      <mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p2_success" @closeAlert="p2_success=false" dismiss>
				Success! CCB has been completed!
			</mdb-alert>
      <!--failure messages-->
			<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p3_fail" @closeAlert="p3_fail=false" dismiss>
				There was an error submitting the CCB notes. Please try again! Error Code P3_fail
			</mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p6" @closeAlert="p6=false" dismiss>
				There was an error retrieving data from the server! Please try again later.
			</mdb-alert>

        <mdb-card class="mb-3 d-flex">
        <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">Quadrus Corporation Audit Reports for ITCRs</h3>
        <mdb-card-body>
          <div ref="mainTable">
            <mdb-col>
              <mdb-btn class="QuadrusButton" v-on:click="showReportOptions">Generate Audit Report</mdb-btn>
            </mdb-col>
            <br><br>
            <h4 class="font-weight-bold mb-3">Audit Status</h4>
            <mdb-col class="d-flex align-items-center justify-content-center">
              <mdb-row>
                <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showPending" id="showPending" name="showPending" @click.native.prevent="handleToggle('pending')" label="Pending"/>
                <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showPass" id="showPass" name="showPass" @click.native.prevent="handleToggle('pass')" label="Pass"/>
                <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showFail" id="showFail" name="showFail" @click.native.prevent="handleToggle('fail')" label="Fail"/>
              </mdb-row>
            </mdb-col>
            <br><br>

            <div v-if="showFail">
              <h5 class="mb-3">CCB - Audit Fail Review</h5>
              <mdb-col v-if="showFail" class="d-flex align-items-center justify-content-center">  
                <mdb-row>
                  <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showCCBComplete" id="showCCBComplete" 
                  @click.native.prevent="toggleFailed" name="showCCBComplete" label="CCB Completed"/>
                </mdb-row>
              </mdb-col>
            </div>

            <QDataTable v-if="!showFail" id='auditTable' :rowData="this.itcrData.rowData" :filterWords="this.itcrData.filterWords" :headers="this.itcrData.columns" 
            :btnName="!showPending ? 'Review Audit' : 'Start Audit'" :hasBtn="!isCM || isAdministration || !showPending" @use-method='auditITCR' :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
            </QDataTable>
            <QDataTable v-if="showFail" id='auditTable2' :rowData="this.itcrData.rowData" :filterWords="this.itcrData.filterWords" :headers="this.itcrData.columns" 
            :btnName="'Review Audit'" :hasBtn="true" @use-method='auditITCR' :hasBtn2="isCM || isAdministration" :btnName2="!showCCBComplete ? 'Start CCB' : 'View CCB'" 
            @use-method-2='completeCCB' :class="{'hideTable': !isSetUp, 'fadeIn' : isSetUp}">
            </QDataTable>
          </div>
          <div :class="{'hideSpinner': isSetUp}" class="p-4">
            <span class="spinner-border spinner-border-xl" id="loadSpinner" role="status" aria-hidden="true"></span>
          </div>
        </mdb-card-body>
        </mdb-card>

        <div v-if="viewCCB" ref="viewCCB">
          <mdb-card class="mb-3 d-flex">
            <h3 class="card-header stylish-color white-text text-center font-weight-bold text-uppercase py-4">CCB Meeting for ITCR #{{ this.ITCRid }}
              <mdb-icon @click.native="resetData, viewCCB = false" class="closeDetailsBtn" color="white" fas icon="times" />
            </h3>
            <mdb-card-body>
              <div class="fadeIn">
                <mdb-col>
                  <mdb-row class="d-flex align-items-center justify-content-center">
                    <mdb-btn @click.native="auditITCR(holdData)">View Audit Details</mdb-btn>
                    <mdb-btn @click.native="openITCR">View ITCR Details</mdb-btn>
                  </mdb-row>
                <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p6_fail" @closeAlert="p6_fail=false" dismiss>
                  Missing Required Fields
                </mdb-alert>
                </mdb-col>
                <form @submit.prevent="" class="was-validated">
                  <mdb-input label='CCB Notes' v-model="ccbNotes" outline type='textarea' :rows="8" maxlength="5000"
                    invalid-feedback="Please Input ITCR Description" valid-feedback="Looks Good!" :required="!ccbComplete" :disabled="ccbComplete"/>
                </form>
              </div>
              <br>

              <mdb-row class="d-flex justify-content-center">
                <mdb-btn v-if="!ccbComplete" class="m-4 QuadrusButton" @click.native="submitCCB">Submit CCB Meeting Notes</mdb-btn>
              </mdb-row>
            </mdb-card-body>
          </mdb-card>
        </div>


        <mdb-modal size="xl" centered :show="viewReport" @close="viewReport = false" style="z-index: 9999 !important;">
            <mdb-modal-header>
              <mdb-modal-title><p class="h2 grey-text">Generate an Audit Report for ITCRs</p></mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body style="font-size: 0.9em;">
              <h5 class="card-title font-weight-bold text-uppercase mt-2">Audit Status</h5>
              <mdb-row class="d-flex align-items-center justify-content-center">
                <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showPendingReport" id="showPending2" name="showPending2" label="Pending" @click.native.prevent="handleReportToggle('pending')"/>
                <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showPassReport" id="showPass2" name="showPass2" label="Pass" @click.native.prevent="handleReportToggle('pass')"/>
                <mdb-input class="mb-0 mt-2" type="checkbox" v-model="showFailReport" id="showFail2" name="showFail2" label="Fail" @click.native.prevent="handleReportToggle('fail')"/>
              </mdb-row>
              <br>
              <mdb-row>
                  <mdb-col>
                    <h5 class="card-title font-weight-bold text-uppercase mt-2">Date (Optional)</h5>
                    <p>By default, all data for the current year will be included. If you want a specific month or year, use this filter below </p>
                    <hr>
                    <mdb-select label="Month" @getValue="setScopeMonth" v-model="monthOptions" required />
                    <mdb-input type="number" label="Year" v-model="scopeYear" :min="2021" />
                </mdb-col>
              </mdb-row>
            </mdb-modal-body>

          <mdb-modal-footer class="d-flex justify-content-between">
            <mdb-btn color="secondary" @click.native="viewReport = false, scopeMonth = 0, scopeYear = new Date().getFullYear()">Close</mdb-btn>
            <download-csv
              class="btn QuadrusButton"
              :data="exportData"
              name="auditReportITCR.csv">
              Generate Report
            </download-csv>
          </mdb-modal-footer>
      </mdb-modal>

        <mdb-modal size="xl" centered :show="viewModal" @close="resetData">
            <mdb-modal-header>
                <mdb-modal-title><p class="h2 grey-text">Audit ITCR #{{ITCRid}}</p></mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body style="font-size: 0.9em;">
              <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2_fail" @closeAlert="p2_fail=false" dismiss>
                Fill out all required fields.
              </mdb-alert>
                <form @submit.prevent="" class="was-validated">
                    <mdb-row>
                        <mdb-col>
                            <mdb-btn @click.native="openITCR">View ITCR details</mdb-btn>
                        </mdb-col>
                    </mdb-row>
                    <br>

                    <mdb-row>
                        <mdb-col>
                            <mdb-input class="mb-3 readonly-inputs" v-model="auditorName" label="Name" readOnly/>
                        </mdb-col>
                        <mdb-col>
                            <mdb-input class="mb-3 readonly-inputs" type="text" v-model="auditDate" label='Audit Date' id="auditDate" title='Audit Date' readOnly/>
                        </mdb-col>
                    </mdb-row>

                    <mdb-col>
                        <mdb-input class="mb-3 no-resize-textarea" type="textarea" :rows="4" outline v-model="auditActions" label="Additional Actions"
                        maxlength="5000" :readOnly="auditCompleted" :required="auditDisposition == 'Fail'"
                        invalid-feedback="Please Input Actions" valid-feedback="Looks Good!"/>
                    </mdb-col>
                    <mdb-col>
                        <mdb-input class="mb-3 no-resize-textarea" type="textarea" :rows="4" outline v-model="auditNotes" label="Notes" required
                        invalid-feedback="Please Input Notes" valid-feedback="Looks Good!" maxlength="5000" :readOnly="auditCompleted" />
                    </mdb-col>

                    <mdb-col>
                        <mdb-select class="mb-3" v-model="auditDispositionOptions" @getValue="auditDisposition = $event" label="Disposition" :disabled="auditCompleted"/>
                    </mdb-col>
                    <div v-if="!auditDisposition && !auditCompleted" class="invalid-feedback d-block">Please select an option.</div>
                    <div v-else-if="!auditCompleted" class="valid-feedback d-block">Looks Good!</div>
                </form>
            </mdb-modal-body>

            <mdb-modal-footer class="d-flex justify-content-between">
                <mdb-btn color="secondary" @click.native="resetData">Close</mdb-btn>
                <mdb-btn class="QuadrusButton" v-if="!auditCompleted" v-on:click="submitAudit">Submit</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>
    </mdb-container>
  </div>
</template>
<style>
.roundButton {
  border: none;
  font-size: 1.5em;
  width: 15%; 
  border-radius: 25%;
  padding: .1em;
}
.no-resize-textarea > textarea {
    height: 120px !important;
    max-height: 120px !important;
    overflow-y: auto !important;
    resize: none !important;
    }
</style>
<script>
import { mdbCard, mdbCardBody, mdbContainer, mdbRow, mdbCol, mdbBtn, mdbInput, mdbModal, mdbIcon, 
  mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbSelect, mdbAlert } from 'mdbvue';
import QDataTable from '@/components/QDataTable.vue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import { formatDate } from '@/assets/js/formatDate.js';
import * as sendEmail from '@/assets/js/email.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

export default {
	name: 'View-QCRs',
	components: {
    mdbCard,
    mdbCardBody,
    mdbContainer,
    QDataTable,
    mdbRow,
    mdbCol, 
    mdbBtn,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbSelect,
    mdbAlert,
    mdbIcon
  },

  data() {
    return {
      isSetUp: false,
      p1_success: false,
      p1_fail: false,
      p2_fail: false,
      p6_fail: false,
      p2_success: false,
      p3_fail: false,
      p6: false,

      isCM: false,
      isAdministration: false,

      showCCBComplete: false,
      viewReport: false,
      viewCCB: false,
      scopeMonth: 0,
      scopeYear: new Date().getFullYear(),
      monthOptions: [
        { text: 'None', value: '0', selected: true },
        { text: 'January', value: '1', selected: false },
        { text: 'February', value: '2', selected: false },
        { text: 'March', value: '3', selected: false },
        { text: 'April', value: '4', selected: false },
        { text: 'May', value: '5', selected: false },
        { text: 'June', value: '6', selected: false },
        { text: 'July', value: '7', selected: false },
        { text: 'August', value: '8', selected: false },
        { text: 'September', value: '9', selected: false },
        { text: 'October', value: '10', selected: false },
        { text: 'November', value: '11', selected: false },
        { text: 'December', value: '12', selected: false }
      ],
      
      ITCRid: '',
      submitDate: '',
      changeDescription: '',
      closeDate: '',
      stage: '',
      siaDisposition: '',
      workDisposition: '',
      verificationPass: '',
      showPending: false,
      showPass: false,
      showFail: false,
      auditCompleted: false,
      itcrType: '',

      ccbNotes: '',
      ccbComplete: false,

      showPendingReport: true,
      showPassReport: false,
      showFailReport: false,

      viewModal: false,
      auditorName: '',
      auditDate: new Date().toISOString().substr(0, 10),
      auditDispositionOptions: [{text: 'Pass', value: 'Pass'},{text: 'Fail', value: 'Fail'}],
      auditDisposition: '',
      auditNotes: '',
      auditActions: '',

      holdData: [],
      allITCRData: [],

      reportTable: [],

      itcrData: {
        columns: [  
          {
            colTitle: 'ITCR Number',
            sortBy: 'ITCRnumber'
          },
          {
            colTitle: 'Date Created',
            sortBy: 'submitDate'
          },
          {
            colTitle: 'Date Closed',
            sortBy: 'closeDate'
          },
          {
            colTitle: 'Change being implemented',
            sortBy: 'changeDescription'
          },
          {
            colTitle: 'SIA',
            sortBy: 'siaDisposition'
          },
          {
            colTitle: 'Work Status',
            sortBy: 'workDisposition'
          },
          {
            colTitle: 'Verification Status',
            sortBy: 'verificationPass'
          },
          {
            colTitle: 'Action',
            sortBy: ''
          },
        ],
        rowData: [],
        filterWords: [
          'ITCRnumber',
          'submitDate',
          'closeDate',
          'changeDescription',
          'siaDisposition',
          'workDisposition',
          'verificationPass',
        ]
      }

    }
  },
  
  methods: {
    setScopeMonth: function(value)
    {
      this.scopeMonth = parseInt(value);
    },

    showReportOptions: async function() {
      this.viewReport = true;
      this.reportTable = await this.populateITCRData(this.showFailReport, this.showPassReport, this.showPendingReport, false);
    },

    handleToggle: async function(type) {
      var col = this.itcrData.columns.findIndex(item => item.colTitle === "Action");
      if(this.isCM && !this.Admin && col <= 0){
        this.itcrData.columns.push({colTitle: 'Action', sortBy: ''});
      }
      
      if (type === 'fail') {
        if (this.showFail) {
          this.showPending = true;
          this.showFail = false;
        } else{
          this.showFail = true;
          this.showPending = false;
          this.showPass = false;
        }       
      } else if(type === 'pass') {
        if (this.showPass) {
          this.showPending = true;
          this.showPass = false;
        } else {
          this.showPass = true;
          this.showPending = false;
          this.showFail = false;
        }
      } else if (type === 'pending') {
        if (this.showPending) {
          this.showPass = true;
          this.showPending = false;
        } else {
          this.showPending = true;
          this.showPass = false;
          this.showFail = false;
          if(this.isCM && !this.isAdministration){
            this.itcrData.columns.splice(col, 1);
          }
        }
      }
      this.isSetUp = false;
      if(this.showFail){
        this.filterFailed();
      } else {
        this.itcrData.rowData = await this.populateITCRData(this.showFail, this.showPass, this.showPending);
      }
      this.isSetUp = true;
    },

    handleReportToggle: async function(type) {
      if (type === 'fail') {
        if (this.showFailReport) {
          this.showPendingReport = this.showPassReport ? this.showPendingReport : true;
          this.showFailReport = false;
        } else{
          this.showFailReport = true;
        }       
      } else if(type === 'pass') {
        if (this.showPassReport) {
          this.showPendingReport = this.showFailReport ? this.showPendingReport : true;
          this.showPassReport = false;
        } else {
          this.showPassReport = true;
        }
      } else if (type === 'pending') {
        if (this.showPendingReport) {
          this.showPassReport = this.showFailReport ? this.showPassReport : true;
          this.showPendingReport = false;
        } else {
          this.showPendingReport = true;
        }
      }
      this.reportTable = await this.populateITCRData(this.showFailReport, this.showPassReport, this.showPendingReport);
    },

    toggleFailed: function(){
      this.showCCBComplete = !this.showCCBComplete;
      this.filterFailed();
    },
    filterFailed(){
      this.itcrData.rowData = this.allITCRData.filter(item => {
        const isFail = item.auditDisposition === "Fail";
        const isComplete = item.ccbComplete === this.showCCBComplete;

        return isFail && isComplete;
      });
    },

    resetData: function(){
      this.auditCompleted = false;
      this.p2_fail = false;
      this.viewModal = false;
      this.auditActions = '';
      this.auditNotes = '';
      this.auditDisposition = '';
      this.auditDispositionOptions = [{text: 'Pass', value: 'Pass'},{text: 'Fail', value: 'Fail'}];
      this.auditDate = new Date().toISOString().substr(0, 10);
      this.ccbNotes = '';
    },

    getCCBMemberData: async function(itcrType = this.itcrType){
      let members = [];
      let token = this.$store.getters.getToken;

      try{
        let query = "filters[itcrType][$eq][0]=" + itcrType;
        let ccbResponse = await DatabaseLib.getRequest('strapiDatabase','itcr-ccb-members',token,query,false);
        for(let i = 0; i < ccbResponse.data.data.length; i = i + 1){
          members.push({
            name: ccbResponse.data.data[i].attributes.firstLastName,
            email: ccbResponse.data.data[i].attributes.email,
            username: ccbResponse.data.data[i].attributes.username
          });  
        }
      } catch(error){
        console.log(error);
        return;
      }
      return members;
    },

    //Remind email button for CM
    sendCCBReminder: async function () {
      const emailNotification = `
        The audit failed for ITCR #${this.ITCRid}. 
        This is a reminder that the ITCR is ready for CCB.
        <br>Change Description: ${this.changeDescription}
        <br>Additional Actions: ${this.additionalActions}
        <br>Audit Notes: ${this.auditNotes}
      `;

      const notification = `Failed Audit - ITCR #${this.ITCRid} is ready for CCB.`;
      const token = this.$store.getters.getToken;

      const members = await this.getCCBMemberData();
      const msgIds = [];

      for (const member of members) {
        // Email failure should not prevent the notification from being created.
        try {
          await sendEmail(
            member.email,
            "Audit Failed - IT CCB Reminder",
            emailNotification,
            token,
            `auditITCR&id=${this.ITCRid}`,
            []
          );
        } catch (error) {
          console.error(`Failed to send email to ${member.email}:`, error);
        }

        // Create the notification regardless of whether the email succeeded.
        try {
          const data = {
            data: {
              details: notification,
              notified: false,
              username: member.username,
              userEmail: member.email,
              type: "ITCR Audit"
            }
          };

          const response = await DatabaseLib.postRequest(
            "strapiDatabase",
            "notifications",
            token,
            data
          );

          msgIds.push(response.data.data.id);
        } catch (error) {
          console.error(
            `Failed to create notification for ${member.username}:`,
            error
          );
        }
      }

      // Link the notifications to the ITCR.
      try {
        if (msgIds.length > 0) {
          const data = {
            data: {
              notifications: msgIds
            }
          };

          await DatabaseLib.putRequest(
            "strapiDatabase",
            "itcrs",
            token,
            this.ITCRid,
            data
          );
        }

        this.p3_success = true;

        // Reload notifications.
        this.bus.$emit("fireMethod");
      } catch (error) {
        console.error("Failed to update ITCR with notification IDs:", error);
        this.p5_fail = true;
      }

      window.scroll({
        top: 0,
        behavior: "smooth"
      });
    },



    //===========================================================================================
    //	Method Name	:	populateITCRData
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Gets the QCRs
    //===========================================================================================
    populateITCRData: async function(fail, pass, pending){
      return this.allITCRData.filter(item => {
        const isPending = item.auditComplete === false;
        const isComplete = item.auditComplete === true;
        const isPass = item.auditDisposition === "Pass";
        const isFail = item.auditDisposition === "Fail";
        // Case 1: pending ONLY
        if (pending && !pass && !fail) {
          return isPending;
        }
        // Case 2: pass/fail ONLY (no pending)
        if (!pending && (pass || fail)) {
          return (
            isComplete &&
            (
              (pass && isPass) ||
              (fail && isFail)
            )
          );
        }
        // Case 3: pending + pass/fail
        if (pending && (pass || fail)) {
          return (
            isPending || // include all pending
            (
              isComplete &&
              (
                (pass && isPass) ||
                (fail && isFail)
              )
            )
          );
        }
        // Case 4: nothing selected → return all Closed
        return true;
      });
    },

    getAllITCRData: async function(){
      this.isSetUp = false; 
      let token = this.$store.getters.getToken;
      let query = "filters[closed][$eq][0]=true&populate[1]=failed_itcr_audit&populate[2]=ccbs";
      let response = await DatabaseLib.getRequest('strapiDatabase', 'itcrs',token,query);
      this.allITCRData = [];

      for(let i = 0; i < response.data.data.length; i = i + 1) {
        let itcr = response.data.data[i];
        let failedAudit = false;
        if(response.data.data[i].attributes.failed_itcr_audit.data){
          failedAudit = true;
        }
        
        let meetingNotes = "";
        let ccbData = response.data.data[i].attributes.ccbs.data;
        if(ccbData){
          for(let j = 0; j < ccbData.length; j = j + 1){
            meetingNotes += ccbData[j].attributes.firstLastName + ": " + ccbData[j].attributes.comments + "\n";
          }
        }

        this.allITCRData.push({
          ITCRnumber: itcr.id,
          state: itcr.attributes.stage,
          submitDate: formatDate(itcr.attributes.submitDate),
          submitter: itcr.attributes.submitter,
          changeDescription: itcr.attributes.changeDescription,
          additionalNotes: itcr.attributes.additionalNotes,
          siaReviewerName: itcr.attributes.siaReviewerName,
          siaDisposition: itcr.attributes.siaDisposition,
          siaNotes: itcr.attributes.siaNotes,
          siaCompletionDate: itcr.attributes.siaCompletionDate,
          ccbMeetingNotes: meetingNotes != "" ? meetingNotes : "Dispostion set by: " + itcr.attributes.forceDispositionCM,
          ccbDisposition: itcr.attributes.ccbDisposition,
          ccbCompletionDate: itcr.attributes.ccbCompletionDate,
          techAssignedToWork: itcr.attributes.techAssignedToWork,
          workDisposition: itcr.attributes.workDisposition,
          workNotes: itcr.attributes.workNotes,
          workCompletionDate: itcr.attributes.workCompletionDate,
          testReviewer: itcr.attributes.testReviewer,
          verificationPass: itcr.attributes.verificationPass,
          verificationNotes: itcr.attributes.verificationNotes,
          closeDate: formatDate(itcr.attributes.closeDate),
          auditComplete: itcr.attributes.auditComplete,
          auditActions: itcr.attributes.auditActions,
          auditNotes: itcr.attributes.auditNotes,
          auditDisposition: itcr.attributes.auditDisposition,
          auditDate: formatDate(itcr.attributes.auditDate),
          auditorName: itcr.attributes.auditorName,
          rawSubmitDate: itcr.attributes.submitDate,
          rawCloseDate: itcr.attributes.closeDate,
          rawAuditDate: itcr.attributes.auditDate,
          closeRequestReason: itcr.attributes.closeRequestReason,
          itcrType: itcr.attributes.itcrType,
          urgentRequest: itcr.attributes.urgentRequest,

          //Failed ITCR audit data
          ccbNotes: failedAudit ? response.data.data[i].attributes.failed_itcr_audit.data.attributes.ccbNotes: '',
          ccbComplete: failedAudit ? response.data.data[i].attributes.failed_itcr_audit.data.attributes.ccbComplete: false,
          ccbDate: failedAudit ? response.data.data[i].attributes.failed_itcr_audit.data.attributes.ccbDate: '',
        })
      }
      this.itcrData.rowData = await this.populateITCRData(this.showFail, this.showPass, this.showPending);
      this.isSetUp = true;
      window.scroll({top: 0, behavior: 'smooth'});
    },

    completeCCB: function(data){
      this.holdData = data;
      this.ITCRid = data.ITCRnumber;
      this.ccbNotes = data.ccbNotes;
      this.ccbComplete = data.ccbComplete;
      this.viewCCB = true;
      this.$nextTick(function() {
        this.$refs.viewCCB.scrollIntoView({behavior: 'smooth'})
      })  
    },

    submitCCB: async function(){
      if(!this.ccbNotes){ 
        this.p6_fail = true;
        return;
      }
      let token = this.$store.getters.getToken;

      this.ccbNotes = sanitizeInput(this.ccbNotes, this.$sanitize);

      let data = {
        data: {
          itcr_number: this.ITCRid,
          ccbNotes: this.ccbNotes,
          ccbComplete: true,
          ccbDate: new Date().toISOString()
        }
      }
      try{
        await DatabaseLib.postRequest('strapiDatabase','failed-itcr-audits',token,data);
        this.removeNotification();
      }catch(error){
        this.p3_fail = true;
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }
      this.viewCCB = false;
      this.p2_success = true;
      this.resetData();
      await this.getAllITCRData();
      this.filterFailed();
      window.scroll({top: 0, behavior: 'smooth'});
    },

    removeNotification: async function () {
      let token = this.$store.getters.getToken;
      //delete notifications
      try{
        let query = "filters[id][$in][0]=" + this.ITCRid + "&populate[1]=notifications";
        let response = await DatabaseLib.getRequest('strapiDatabase','itcrs',token,query,false);
        for(var i = 0; i < response.data.data[0].attributes.notifications.data.length; i++){
          if(response.data.data[0].attributes.notifications.data[i].attributes.type == 'ITCR Audit'){
            await DatabaseLib.deleteRequest('strapiDatabase','notifications',token,response.data.data[0].attributes.notifications.data[i].id);          
          }
        }
        // Load notifications
        this.bus.$emit('fireMethod');
      }catch(error){
        console.log(error);
      }
    },

    getLoggedInUser: async function () {
      let token = this.$store.getters.getToken;      
      try 
			{
				let response = await DatabaseLib.getRequest('strapiDatabase','users/me',token);
				let tempFName = response.data.firstName;
				let tempLName = response.data.lastName;

				return tempFName + " " + tempLName;
			} 
			catch (error)
			{
				console.log(error);
				window.scroll({top: 0, behavior: 'smooth'});
				this.p6 = true;
				return;
			}
    },

     
    //===========================================================================================
    //	Method Name	:	auditITCR
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Loads audit form
    //===========================================================================================
    auditITCR: async function(data) {
      this.p2_fail = false;
      this.viewModal = true;
      this.auditCompleted = data.auditComplete;
      this.auditorName = await this.getLoggedInUser();
      this.auditActions = data.auditActions;
      this.auditNotes = data.auditNotes;
      this.ITCRid = data.ITCRnumber;
      this.itcrType = data.itcrType;

      if(data.auditComplete){
        this.auditDisposition = data.auditDisposition;
        this.auditDate = formatDate(data.auditDate);
        this.auditorName = data.auditorName;

        let holdOptions = [{text: 'Pass', value: 'Pass'},{text: 'Fail', value: 'Fail'}];
        for(let i = 0; i < holdOptions.length; i = i + 1) {
            if (holdOptions[i].value == this.auditDisposition)
            {
                holdOptions[i].selected = true;
            }
        }
        this.auditDispositionOptions = holdOptions;
      }
    },

    openITCR: function() {
        const routeData = this.$router.resolve({
          name: 'viewITCRDetails',
          query: { id: this.ITCRid }
        });
        window.open(routeData.href, '_blank');
    },

    submitAudit: async function() {
      let token = this.$store.getters.getToken;
      
      if(!this.auditDisposition || !this.auditNotes || (!this.auditActions && this.auditDisposition == 'Fail')){ 
        this.p2_fail = true;
        return;
      }

      this.auditDisposition = sanitizeInput(this.auditDisposition, this.$sanitize);
      this.auditNotes = sanitizeInput(this.auditNotes, this.$sanitize);
      this.auditActions = sanitizeInput(this.auditActions, this.$sanitize);
      
      let body = {
        data: {
          auditorName: await this.getLoggedInUser(),
          auditDate: new Date().toISOString(),
          auditDisposition: this.auditDisposition,
          auditNotes: this.auditNotes,
          auditActions: this.auditActions,
          auditComplete: true
        }
      }
      if(this.auditDisposition == 'Fail'){
        await this.sendCCBReminder();
      }
      try{
        await DatabaseLib.putRequest('strapiDatabase', 'itcrs',token, this.ITCRid,body);
        this.p1_success = true;
      }catch(error){
        console.log(error);
        this.p1_fail = true;
      }
      this.resetData();
      this.getAllITCRData();
    },

    //===========================================================================================
    //	Method Name	:	checkGroups
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Determine what groups the user belongs to
    //===========================================================================================
    checkGroups: function(){
      if (this.$store.getters.getGroups.includes("Administration")){
        this.isAdministration = true;
      }
      if (this.$store.getters.getGroups.includes("CM")){
        this.isCM = true;
      }
      this.handleToggle('pending');
    },

    //===========================================================================================
    //	Method Name	:	bindProps
    //	Description
    //	-----------------------------------------------------------------------------------------
    //	Get data passed to the page in props
    //===========================================================================================
    bindProps: function(){
      let id = parseInt(this.$route.query.id);
      if(id){
        this.handleToggle('fail');
      }
    }
   
  },
  computed: {
    exportData() {
      const combined = [];
      let monthSet = this.scopeMonth != 0 ? true : false;
      let yearSet = this.scopeYear != 0 ? true : false;
      let gte = '';
      let lt = '';

      let endMonth = parseInt(this.scopeMonth)+1;
      let endYear = parseInt(this.scopeYear);
      if (endMonth == 13)
      {
        endMonth = 1;
        endYear = parseInt(this.scopeYear) + 1;
      }
      if(monthSet && yearSet){
        gte = this.scopeYear+'-'+('0'+this.scopeMonth).slice(-2)+'-01';
        lt = endYear +'-'+('0' + (endMonth)).slice(-2) + '-01';
      } else if(yearSet && !monthSet){
        gte = this.scopeYear+'-01-01';
        lt = (endYear+1) +'-01-01';
      }

      this.reportTable.forEach(newObj => {
        if(((!newObj.auditDisposition && this.showPendingReport) || ((monthSet || yearSet) && newObj.auditDate >= gte && newObj.auditDate <= lt))){
          combined.push({
            'ITCR Number': newObj.ITCRnumber || '',
            'Date Opened': newObj.rawSubmitDate || '',
            'Date Closed': newObj.rawCloseDate || '',
            'Submitter': newObj.submitter || '',
            'Change Description': newObj.changeDescription || '',
            'Additional Notes': newObj.additionalNotes || '',
            'Urgent Request': newObj.urgentRequest || false,
            'SIA Reviewer': newObj.siaReviewerName || '',
            'SIA Review Date': newObj.siaCompletionDate || '',
            'SIA Disposition': newObj.siaDisposition || '',
            'Security Impact': newObj.siaNotes || '',
            'CCB Reviewers': newObj.ccbMeetingNotes || '',
            'CCB Review Date': newObj.ccbCompletionDate || '',
            'CCB Disposition': newObj.ccbDisposition || '',
            'Tech Assigned': newObj.techAssignedToWork || '',
            'Work Disposition': newObj.workDisposition || '',
            'Work Notes': newObj.workNotes || '',
            'Work Completion Date': newObj.workCompletionDate || '',
            'Verified By': newObj.testReviewer || '',
            'Test Notes': newObj.verificationNotes || '',
            'Test Disposition': newObj.verificationPass || '',
            'Reason For Closing': newObj.closeRequestReason || '',
            'Audit Complete': newObj.auditComplete || false,
            'Auditor Name': newObj.auditorName || '',
            'Audit Date': newObj.rawAuditDate || '',
            'Audit Disposition': newObj.auditDisposition || '',
            'Audit Notes': newObj.auditNotes || '',
            'Audit Actions': newObj.auditActions || '',

            // failed audit
            'CCB Date for Failed Audit': newObj.auditDisposition == 'Fail' ? newObj.ccbDate: 'N/A',
            'CCB Completed for Failed Audit': newObj.auditDisposition == 'Fail' ? newObj.ccbComplete || false: 'N/A',
            'CCB Notes for Failed Audit': newObj.auditDisposition == 'Fail' ? newObj.ccbNotes : 'N/A',
            
          })
        }
      })
      return combined;
    },
  }, 


  mounted() {
    this.bindProps();
    this.checkGroups();
    this.getAllITCRData();
    window.scroll({top: 0, behavior: 'smooth'});
  }
}
</script>
